import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The landing child of `/onboarding`. The layout above owns that segment as a real path — the guard lives
 * there — so the bare URL matches, and this is what gives it a destination.
 *
 * Not removable. Without an index child the layout still matches `/onboarding` and still renders, with
 * nothing in its `<Outlet/>`: the bare URL becomes an empty onboarding shell, not the 404 the pathless
 * `(onboarding)` group used to give.
 */
export const Route = createFileRoute('/_authenticated/onboarding/')({
  beforeLoad() {
    throw redirect({ to: '/onboarding/1', replace: true });
  },
});
